<section id="loading-message" [ngClass]="[messages.length === 0 ? 'messages-loaded' : '']">
  <ul>
    <li *ngFor="let message of messages" @transitionNewMessageInOut>
      <p>
        {{message.message}}
        <span *ngIf="!message.complete" class="input-loading-spinner spinner-border spinner-border-sm"></span>
        <svg *ngIf="message.complete" class="checkmark" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 52">
          <circle class="checkmark__circle" cx="26" cy="26" r="25" fill="none"/>
          <path class="checkmark__check" fill="none" d="M14.1 27.2l7.1 7.2 16.7-16.8"/>
        </svg>
      </p>
    </li>
  </ul>
</section>
